const STORAGE_KEY = 'cfr-tz-detection-dismissed';

// Storing the dismissed browser zone (not a boolean) is what makes the alert come back by
// itself once the browser reports a different zone.
export const getDismissedTimeZone = (): string | null => {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null; // Safari private mode / storage disabled
  }
};

export const setDismissedTimeZone = (timeZone: string): void => {
  try {
    localStorage.setItem(STORAGE_KEY, timeZone);
  } catch {
    // best effort — a failed write only means the alert shows again next session
  }
};
